/* eslint-disable camelcase */
const CONSUMER_DISPLAY_VEHICLE = {
  dtm_fid: 112,
  promo_id: '70'
};

const CONSUMER_DISPLAY_SERVICES = {
  dtm_fid: 112,
  promo_id: '71'
};

const CONSUMER_DISPLAY_TIME = {
  dtm_fid: 112,
  promo_id: '72'
};

const CONSUMER_DISPLAY_REVIEW = {
  dtm_fid: 112,
  promo_id: '73'
};

const CONSUMER_CONFIRM = {
  dtm_fid: 113,
  promo_id: '74'
};
/* eslint-enable camelcase */

export const DOTOMI_EVENTS = Object.freeze({
  VEHICLE: CONSUMER_DISPLAY_VEHICLE,
  SERVICES: CONSUMER_DISPLAY_SERVICES,
  TIME: CONSUMER_DISPLAY_TIME,
  REVIEW: CONSUMER_DISPLAY_REVIEW,
  CONFIRM: CONSUMER_CONFIRM
});

export const COBALT_EVENTS = Object.freeze({
  START: 'Appointment Initiation',
  LOAD: 'Portal Load',
  VEHICLE: 'Vehicle Select',
  SERVICES: 'Services & Repair Select',
  TIME: 'Appointment Time Select',
  REVIEW: 'Review & Book',
  CONFIRM: 'Appointment Confirm',
  CANCEL: 'Appointment Cancel'
});

export const SCRIPTS_EVENTS = Object.freeze({
  PREAMBLE: 'PREAMBLE',
  START: 'CONSUMER_ENTRY',
  LOAD: 'CONSUMER_LOAD',
  VEHICLE: 'CONSUMER_DISPLAY_VEHICLE',
  SERVICES: 'CONSUMER_DISPLAY_SERVICES',
  TIME: 'CONSUMER_DISPLAY_TIME',
  REVIEW: 'CONSUMER_DISPLAY_REVIEWPG',
  CONFIRM: 'CONSUMER_CONFIRM',
  CANCEL: 'CONSUMER_CANCEL'
});

export const CLICKTRACKING_TRIGGERS = Object.freeze({
  PREAMBLE: 'PREAMBLE',
  START: 'START',
  LOAD: 'LOAD',
  VEHICLE: 'VEHICLE',
  SERVICES: 'SERVICES',
  TIME: 'TIME',
  REVIEW: 'REVIEW',
  CONFIRM: 'CONFIRM',
  CANCEL: 'CANCEL'
});

const PIXALL_COMMON_EVENT_FIELDS = Object.freeze({
  assistChannel: 'Website',
  assistProduct: 'Service',
  assistSubchannel: 'xTime Service Scheduler'
});

export const PIXALL_EVENTS = Object.freeze({
  LOAD: {
    pxamMessageType: 'pxamContentEvent',
    eventType: 'start',
    eventSource: 'application',
    eventFields: {
      applicationType: 'service',
      feature: 'xtime-consumer8',
      ...PIXALL_COMMON_EVENT_FIELDS
    }
  },
  START: {
    pxamMessageType: 'pxamContentEvent',
    eventType: 'ajaxPageView',
    eventFields: {
      pageType: 'service',
      label: 'appointment_entry',
      feature: 'xtime-consumer8',
      ...PIXALL_COMMON_EVENT_FIELDS
    }
  },
  VEHICLE: {
    pxamMessageType: 'pxamContentEvent',
    eventType: 'ajaxPageView',
    eventFields: {
      pageType: 'service',
      label: 'appointment_vehicle',
      feature: 'xtime-consumer8',
      ...PIXALL_COMMON_EVENT_FIELDS
    }
  },
  SERVICES: {
    pxamMessageType: 'pxamContentEvent',
    eventType: 'ajaxPageView',
    eventFields: {
      pageType: 'service',
      label: 'appointment_services',
      feature: 'xtime-consumer8',
      ...PIXALL_COMMON_EVENT_FIELDS
    }
  },
  TIME: {
    pxamMessageType: 'pxamContentEvent',
    eventType: 'ajaxPageView',
    eventFields: {
      pageType: 'service',
      label: 'appointment_time',
      feature: 'xtime-consumer8',
      ...PIXALL_COMMON_EVENT_FIELDS
    }
  },
  REVIEW: {
    pxamMessageType: 'pxamContentEvent',
    eventType: 'ajaxPageView',
    eventFields: {
      pageType: 'service',
      label: 'appointment_review',
      feature: 'xtime-consumer8',
      ...PIXALL_COMMON_EVENT_FIELDS
    }
  },
  CONFIRM: {
    pxamMessageType: 'pxamConversion',
    formType: 'xtime_confirm_appt',
    eventFields: {
      feature: 'xtime-consumer8',
      eventType: 'goal',
      eventSource: 'sale'
    }
    // formEventId: guid()
  },
  CANCEL: {
    pxamMessageType: 'pxamContentEvent',
    eventType: 'cancel',
    eventSource: 'application',
    eventFields: {
      applicationType: 'service',
      feature: 'xtime-consumer8',
      ...PIXALL_COMMON_EVENT_FIELDS
    }
  }
});

export const COMPANIES = Object.freeze({
  AUTONATION: 'AUTONATION'
});



// WEBPACK FOOTER //
// ./src/constants/clickTracking.js